import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement logistik-component-error-message
 */
@customElement('logistik-component-error-message')
export class LogistikComponentErrorMessage extends ChemistryLitElement {
  @property({ attribute: true, reflect: true }) type: 'error' | 'warning' | 'info' = 'error';

  override render() {
    return html`
      <cr-flex
        horizontal
        padding="xs"
        crossaxis-center
        ${css({
          background: this._getBackgroundColor(),
          border: `1px solid ${this._getMessageColor()}`,
          borderRadius: '5px',
        })}
      >
        <cr-icon
          ${css({
            marginRight: this.spacing.xs,
            fontSize: '1.4rem',
            color: this._getMessageColor(),
          })}
          >${this._getIcon()}</cr-icon
        >
        <cr-text bold ${css({ display: 'flex', alignItems: 'center' })}>
          ${this._getText()}
          <cr-text ${css({ marginLeft: this.spacing.xs })}>
            <slot></slot>
          </cr-text>
        </cr-text>
      </cr-flex>
    `;
  }

  private _getText() {
    switch (this.type) {
      case 'error':
        return 'Fehler:';
      case 'warning':
        return 'Warnung:';
      case 'info':
        return 'Info:';
      default:
        return 'Info:';
    }
  }

  private _getIcon() {
    switch (this.type) {
      case 'error':
        return 'warning';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  }

  private _getMessageColor() {
    switch (this.type) {
      case 'error':
        return '#ff5656';
      case 'warning':
        return '#ffc756';
      case 'info':
        return '#4a90e2';
      default:
        return '#4a90e2';
    }
  }

  private _getBackgroundColor() {
    switch (this.type) {
      case 'error':
        return '#ff565630';
      case 'warning':
        return '#ffc7562f';
      case 'info':
        return '#4a90e230';
      default:
        return '#4a90e230';
    }
  }
}
